export default __webpack_public_path__ + "static/media/celo.c135fc9f.svg";